<template>
  <div class="station-tile">
    <div class="station-image" :class="{ 'no-logo': !station.logo  }" :style="logoPath"></div>
    <div class="station-info">
      <h3>{{ station.name }}</h3>
      <span>Reference identifier: {{ station.refId }}</span>
    </div>
  </div>
</template>

<script>
import DivegasLogo from '@/assets/logo_all_blue.png'
import StationsControls from './StationsControls'

export default {
  name: 'StationTile',
  components: { StationsControls },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  computed: {
    logoPath () {
      let obj = { backgroundImage: '' }
      if (this.station.logo) {
        obj.backgroundImage = 'url(' + this.station.logo.absolutePath + ')'
      } else {
        obj.backgroundImage = 'url(' + DivegasLogo + ')'
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
  .station-tile {
    width: 100%;
    height: 225px;
    background-color: #fdfdfd;
    transition: background-color .2s linear;
    cursor: pointer;

    &:hover {
      background-color: $bg;
    }


    h3 {
      text-align: center;
      color: $text;
      font-size: 14px;
      margin: 0;
    }

    span {
      font-size: 12px;
      text-align: center;
      color: $text-light;
      width: 100%;
      display: inline-block;
    }
  }

  .no-logo {
    width: 50% !important;
  }

  .station-image {
    background-color: transparent;
    margin: 0 auto;
    width: 100%;
    height: 150px;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .station-info {
    width: 100%;
    height: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    -webkit-box-shadow: 0px -3px 30px 0px rgba($text-light,0.075);
    -moz-box-shadow: 0px -3px 30px 0px rgba($text-light,0.075);
    box-shadow: 0px -3px 30px 0px rgba($text-light,0.075);
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Stations/StationTile.vue